module.exports = __webpack_public_path__ + "img/ye.cd13006c.svg";